module.exports = __webpack_public_path__ + "static/media/arlanda-express.940de5f9.svg";